import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { YEAR_ANIMATIONS_DIRECTION } from '../../../config/constants';
import styles from './styles.module.css';

const YearComponent = ({
  year,
  className,
  yearClassName,
  yearIconClassName,
}) => {
  const [countdownYear, setCountdownYear] = useState(year);

  const yearRef = useRef(null);

  useEffect(
    () => {
      const countDownYears = mutationList => {
        if (
          mutationList[0].target.classList.contains(
            YEAR_ANIMATIONS_DIRECTION.FORWARD
          )
        ) {
          let counter = parseInt(year) + 5;
          let yearReturned = setInterval(() => {
            counter--;
            setCountdownYear(counter);
            if (counter === parseInt(year)) {
              setCountdownYear(counter);
              clearInterval(yearReturned);
            }
          }, 180);
        }

        if (
          mutationList[0].target.classList.contains(
            YEAR_ANIMATIONS_DIRECTION.BACKWARD
          )
        ) {
          let counter = parseInt(year) - 5;
          let yearReturned = setInterval(() => {
            counter++;
            setCountdownYear(counter);
            if (counter === parseInt(year)) {
              setCountdownYear(counter);
              clearInterval(yearReturned);
            }
          }, 180);
        }
      };

      const observer = new MutationObserver(countDownYears);

      observer.observe(yearRef.current, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false,
      });
    },
    [year]
  );

  return (
    <div
      className={`${className} ${styles.year}`}
      id={`year-${year}`}
      ref={yearRef}>
      {year && (
        <div className={`${yearClassName} ${styles.yearTitle}`}>
          {countdownYear}
        </div>
      )}
      <div className={`${yearIconClassName} ${styles.yearIcon}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g>
                <path
                  id="Layer0_36_MEMBER_1_1_STROKES"
                  data-name="Layer0 36 MEMBER 1 1 STROKES"
                  d="M14,14a4.13,4.13,0,0,1-3,1.26A4.3,4.3,0,0,1,6.71,11,4.3,4.3,0,0,1,11,6.71,4.3,4.3,0,0,1,15.29,11,4.13,4.13,0,0,1,14,14Z"
                  style={{
                    fill: 'none',
                    stroke: '#000',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: '2px',
                  }}
                />
                <path
                  id="Layer0_36_MEMBER_1_1_STROKES-2"
                  data-name="Layer0 36 MEMBER 1 1 STROKES"
                  d="M18.06,18.07A9.62,9.62,0,0,1,11,21a9.62,9.62,0,0,1-7.06-2.93A9.63,9.63,0,0,1,1,11,9.62,9.62,0,0,1,3.93,3.94,9.63,9.63,0,0,1,11,1a9.63,9.63,0,0,1,7.07,2.94A9.62,9.62,0,0,1,21,11,9.63,9.63,0,0,1,18.06,18.07Z"
                  style={{
                    fill: 'none',
                    stroke: '#000',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: '2px',
                  }}
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

YearComponent.propTypes = {
  className: PropTypes.string.isRequired,
  yearIconClassName: PropTypes.string.isRequired,
  yearClassName: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default YearComponent;
